export const getCabinetRole = (accountId, marketplaces, normalizeId) => {
    if (!accountId) return null;
    const account = marketplaces.find((item) => normalizeId(item.id) === normalizeId(accountId));
    return account?.my_role || null;
};

export const getWorkspaceRole = (workspace, userId, normalizeId) => {
    if (!workspace) return null;
    if (workspace.owner_user_id && normalizeId(workspace.owner_user_id) === normalizeId(userId)) {
        return 'owner';
    }
    const member = (workspace.members || []).find(
        (item) => normalizeId(item.user_id) === normalizeId(userId)
    );
    return member?.role || null;
};

export const getOwnershipScopeLabel = (transfer, getWorkspaceById, marketplaces) => {
    if (!transfer) return '';
    if (transfer.scope_type === 'workspace') {
        const workspace = getWorkspaceById(transfer.scope_id);
        return workspace?.name || 'Проект';
    }
    if (transfer.scope_type === 'cabinet') {
        const account = marketplaces.find((item) => item.id === transfer.scope_id);
        return account?.account_name || 'Кабинет';
    }
    return 'Объект';
};
